import { useEffect, useRef, useState } from "react";
import CustomButton from "../../Atoms/CustomButton";
import "./ReminderModal.css";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import { putVisitorLogReminderRequest } from "../../../Redux/VisitorLogs/VisitorLogsActions";
import {
  DEFAULTS,
  PRINT_FONT_SIZE,
  PRINT_FONT_STYLE,
  PRINT_FONT_WEIGHT,
  PS_LOGO_IMG,
} from "../../../Constant";
import AvailableStatus from "../../Atoms/AvailableStatus";
import BorderAllIcon from "@mui/icons-material/BorderAll";
import DataObjectIcon from "@mui/icons-material/DataObject";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../Atoms/CustomSelect";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../Atoms/CustomInput";

const ReminderModal = ({ data, handleClose, mode = "REMINDER" }) => {
  const reversedData = [...data].reverse();
  const navigate = useNavigate();
  const [currentReminderIndex, setCurrentReminderIndex] = useState(0);
  const currentReminder = reversedData[currentReminderIndex];
  const handlePrev = () => {
    if (currentReminderIndex > 0) {
      setCurrentReminderIndex(currentReminderIndex - 1);
    }
  };

  const dispatch = useDispatch();
  const handleNext = () => {
    if (currentReminderIndex < reversedData.length - 1) {
      setCurrentReminderIndex(currentReminderIndex + 1);
    }
  };

  const formik = useFormik({
    initialValues: {
      font_weight: "600",
      font_style: "normal",
      font_size: "14px",
    },
    onSubmit: () => {
      handlePrint();
    },
    validationSchema: Yup.object().shape({
      font_weight: Yup.string().required("Required"),
      font_style: Yup.string().required("Required"),
      font_size: Yup.string().required("Required"),
    }),
  });

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") handlePrev();
      if (event.key === "ArrowRight") handleNext();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [currentReminderIndex]);

  const { getUserResponse } = useSelector((state) => state.user);

  const time_zone =
    getUserResponse?.data?.settings?.time_zone || DEFAULTS.TIME_ZONE;

  const [viewMode, setViewMode] = useState("table");
  const contentRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: "Pass Details",
  });
  const fields = [
    {
      label: "PRIORITY LEVEL",
      value:
        mode === "REMINDER"
          ? () => (
              <AvailableStatus
                status={currentReminder?.priority}
                customCls={
                  currentReminder?.priority === "HIGH"
                    ? "index-red"
                    : "index-orange-mild"
                }
              />
            )
          : null,
      condition: mode === "REMINDER",
    },
    {
      label: "TYPE",
      value: currentReminder?.visitor_log_ref?.other_details?.type?.name,
    },
    {
      label: "VISITOR ID",
      value: currentReminder?.visitor_log_ref?.visitor_id,
    },
    {
      label: "VISITOR NAME",
      value: currentReminder?.visitor_log_ref?.basic_details?.name,
    },
    {
      label: "CHECK-IN",
      value: currentReminder?.visitor_log_ref?.basic_details?.check_in
        ? moment(currentReminder?.visitor_log_ref?.basic_details?.check_in)
            .tz(time_zone)
            .format("DD-MM-YYYY hh:mm A")
        : "-",
    },
    {
      label: "CONTACT NO",
      value: currentReminder?.visitor_log_ref?.basic_details?.contact_no,
    },
    {
      label: "PURPOSE OF VISIT",
      value:
        currentReminder?.visitor_log_ref?.other_details?.purpose_of_visit?.name,
    },
    {
      label: "FROM",
      value: currentReminder?.visitor_log_ref?.other_details?.from,
    },
    {
      label: "CLIENT",
      value: currentReminder?.visitor_log_ref?.other_details?.client?.name,
    },
    {
      label: "DESTINATION",
      value: currentReminder?.visitor_log_ref?.other_details?.destination?.name,
    },
    {
      label: "BLOCK",
      value: currentReminder?.visitor_log_ref?.other_details?.block,
    },
    {
      label: "FLOOR",
      value: currentReminder?.visitor_log_ref?.other_details?.floor,
    },
    {
      label: "UNIT NO",
      value: currentReminder?.visitor_log_ref?.other_details?.unit_no,
    },
    {
      label: "PASS TYPE",
      value: currentReminder?.visitor_log_ref?.other_details?.pass_type,
    },
    {
      label: "PASS NO",
      value: currentReminder?.visitor_log_ref?.other_details?.pass_no,
    },
    {
      label: "VEHICLE NO",
      value: currentReminder?.visitor_log_ref?.other_details?.vehicle_no,
    },
  ];

  return (
    <div>
      <div ref={contentRef} id="print-area">
        <div className="mb-2 sidebar-logo-container">
          <img className="mb-1" style={{ width: "100px" }} src={PS_LOGO_IMG} />
          <h4
            style={{
              fontWeight: formik.values.font_weight,
              fontStyle: formik.values.font_style,
            }}
          >
            TrackTecH
          </h4>
          <p
            style={{
              fontWeight: formik.values.font_weight,
              fontStyle: formik.values.font_style,
              fontSize: formik.values.font_size || DEFAULTS.FONT_SIZE,
            }}
          >
            Your gateway is secured with us
          </p>
        </div>
        <div className="view-moder-parent mb-2 d-flex-juscon-sb-align-center gap-5">
          <div className="view-moder d-flex gap-1">
            <div className="icon">
              <BorderAllIcon
                sx={{
                  fontSize: "25px",
                  padding: "1px 4px 1px 4px",
                  backgroundColor: viewMode === "table" ? "whitesmoke" : "",
                }}
                onClick={() => setViewMode("table")}
              />
            </div>
            <div className="vertical-divider" />
            <div className="icon">
              <DataObjectIcon
                sx={{
                  padding: "1px 4px 1px 4px",
                  fontSize: "25px",
                  backgroundColor: viewMode === "normal" ? "whitesmoke" : "",
                }}
                onClick={() => setViewMode("normal")}
              />
            </div>
          </div>
          {reversedData.length > 1 && (
            <div className="reminder-paging gap-2 d-flex-juscon-flex-end-align-center">
              <p className="announce_num">
                {currentReminderIndex + 1} / {reversedData.length}
              </p>
              <div className="d-flex">
                <div onClick={handlePrev} style={{ cursor: "pointer" }}>
                  <KeyboardArrowLeftIcon />
                </div>
                <div onClick={handleNext} style={{ cursor: "pointer" }}>
                  <ChevronRightIcon />
                </div>
              </div>
            </div>
          )}
        </div>
        {viewMode === "normal" ? (
          <div className="mt-3">
            {fields.map(
              ({ label, value, condition = true }) =>
                condition && (
                  <div className="d-flex mt-2" key={label}>
                    <p
                      className="min-width-185"
                      style={{
                        fontWeight: formik.values.font_weight,
                        fontStyle: formik.values.font_style,
                        fontSize: formik.values.font_size || DEFAULTS.FONT_SIZE,
                      }}
                    >
                      {label}
                    </p>
                    :
                    <div className="ml-5">
                      {typeof value === "function" ? (
                        value()
                      ) : (
                        <p
                          style={{
                            fontWeight: formik.values.font_weight,
                            fontStyle: formik.values.font_style,
                            fontSize:
                              formik.values.font_size || DEFAULTS.FONT_SIZE,
                          }}
                        >
                          {value}
                        </p>
                      )}
                    </div>
                  </div>
                )
            )}
          </div>
        ) : (
          <div className="mt-3">
            <table className="reminder-table">
              <tbody>
                {fields.map(
                  ({ label, value, condition = true }, index) =>
                    condition && (
                      <tr key={index}>
                        <td>
                          <p
                            style={{
                              fontWeight: formik.values.font_weight,
                              fontStyle: formik.values.font_style,
                              fontSize:
                                formik.values.font_size || DEFAULTS.FONT_SIZE,
                            }}
                          >
                            {label}
                          </p>
                        </td>
                        <td>
                          {typeof value === "function" ? (
                            value()
                          ) : (
                            <p
                              style={{
                                fontWeight: formik.values.font_weight,
                                fontStyle: formik.values.font_style,
                                fontSize:
                                  formik.values.font_size || DEFAULTS.FONT_SIZE,
                              }}
                            >
                              {value}
                            </p>
                          )}
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <div className="mt-2 cntr mb-3">
        <hr />
        <h6>{"FORMATTING DETAILS"}</h6>
      </div>

      <div className="row">
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Font Size</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="font_size"
            placeholder="Select font size"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.font_size}
            formik={formik}
            data={PRINT_FONT_SIZE}
            errorMsg={formik.touched?.font_size && formik.errors?.font_size}
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Font Weight</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="font_weight"
            placeholder="Select font weight"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.font_weight}
            formik={formik}
            data={PRINT_FONT_WEIGHT}
            errorMsg={formik.touched?.font_weight && formik.errors?.font_weight}
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Font Style</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="font_style"
            placeholder="Select font style"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.font_style}
            formik={formik}
            data={PRINT_FONT_STYLE}
            errorMsg={formik.touched?.font_style && formik.errors?.font_style}
          />
        </div>
      </div>
      <hr />
      <div className="mt-3 btnActnBar">
        {mode === "PRINT" && (
          <CustomButton
            btnType={"secondary"}
            onClick={() => {
              handleClose();
            }}
            label={"Close"}
            action={"CANCEL"}
          />
        )}
        {mode === "REMINDER" && (
          <CustomButton
            btnType={"primary"}
            onClick={() => {
              handleClose();
              navigate(
                `/visitor-logs/view/${currentReminder?.visitor_log_ref?._id}`
              );
            }}
            label={"Show Details"}
            action={"EYE"}
          />
        )}
        <CustomButton
          btnType={"primary"}
          onClick={formik.handleSubmit}
          label={"Print"}
          action={"PRINT"}
        />
        {mode === "REMINDER" && (
          <CustomButton
            btnType={
              currentReminder?.priority === "HIGH" ? "danger" : "secondary"
            }
            onClick={() => {
              dispatch(
                putVisitorLogReminderRequest({ _id: currentReminder?._id })
              );
              handleClose();
            }}
            label={"Mark as Read"}
            action={"DONE"}
          />
        )}
      </div>
    </div>
  );
};
export default ReminderModal;
